import * as _ from 'lodash';
import toastr from 'toastr';
import moment from 'moment';
import {
  setLoader,
  loadApprovalRequests as loadApprovalRequestsInRedux,
  loadWorkRequests as loadWorkRequestsInRedux,
  upsertApprovalRequest as upsertApprovalRequestInRedux,
  upsertWorkRequest as upsertWorkRequestInRedux,
  deleteWorkRequest as deleteWorkRequestInRedux,
  updateApprovalRequests,
  updateWorkRequests,
  setView as setViewPage,
  // clearView as clearViewPage,
} from './reducer';
import ApiService from '../../../service/apiService';
import logUtils from '../../../HelperMethods/LogUtils';
import { updateTaskAfterBulkApproval, REQUEST_TYPE } from '../helper';
import * as TaskMappers from '../../taskView/TaskViewPage/ManageTaskForm/lib/Mapper';
import { TASK_ACTION } from '../../../HelperMethods/constants';
import * as Utility from '../../../HelperMethods/UtilityFunctions';

export function loadApprovalRequests({ fieldId, approverId }) {
  return async (dispatch) => {
    dispatch(setLoader(true));
    try {
      const response = await ApiService.bulkDownloadTasks({
        fieldId,
        approverId,
        isApprovalWorkflow: true,
        approvalStatus: ['pendingapproval', 'onhold', 'needmoreinfo'],
      });
      if (!response) {
        throw new Error('Failed to fetch  Approval Reqests');
      }
      const tasks = response.map((task) => {
        task.assignee = JSON.stringify(task.assignee || {});
        task.data = JSON.stringify(task.data || {});
        return task;
      });
      dispatch(setViewPage('/approvalrequestlist'));
      dispatch(loadApprovalRequestsInRedux(tasks));
    } catch (e) {
      logUtils.logError(e, 'Loading Approval Requests Failed');
      dispatch(loadApprovalRequestsInRedux([]));
    } finally {
      dispatch(setLoader(false));
    }
  };
}

export function loadWorkRequests({ fieldId, requestorId }) {
  return async (dispatch) => {
    dispatch(setLoader(true));
    try {
      const response = await ApiService.bulkDownloadTasks({
        fieldId,
        requestorId,
        isApprovalWorkflow: true,
        approvalStatus: ['pendingapproval', 'onhold', 'needmoreinfo'],
      });
      if (!response) {
        throw new Error('Failed to fetch  Approval Reqests');
      }
      const tasks = response.map((task) => {
        task.assignee = JSON.stringify(task.assignee || {});
        task.data = JSON.stringify(task.data || {});
        return task;
      });
      dispatch(setViewPage('/workrequestlist'));

      dispatch(loadWorkRequestsInRedux(tasks));
    } catch (e) {
      logUtils.logError(e, 'Loading Work Requests Failed');
      dispatch(loadWorkRequestsInRedux([]));
    } finally {
      dispatch(setLoader(false));
    }
  };
}

export function deleteWorkRequest(id) {
  return async (dispatch) => {
    try {
      const response = await ApiService.upsertTask({ id, isDeleted: true });
      if (!response) throw new Error('Didnt receive updated Request from api');
      toastr.success('Request deleted');
      dispatch(deleteWorkRequestInRedux(id));
    } catch (e) {
      logUtils.logError(e, 'Deleting Approval Matrix failed');
    }
  };
}

export function upsertApprovalRequest(
  formValues,
  schema,
  { originalTask, picklistOptions, loggedInUser, fieldId, tenantId, tasksEditMode, stopForSelectedAsset }
) {
  return async (dispatch) => {
    dispatch(setLoader(true));
    try {
      const updatedApprovalRequest = TaskMappers.mapFormValuesToTask(formValues, schema, {
        originalTask,
        picklistOptions,
        loggedInUser,
        fieldId,
        tasksEditMode,
        taskActionBeingDone: TASK_ACTION.UPDATE,
      });
      const response = await ApiService.upsertTask(updatedApprovalRequest);
      toastr.success('Work Request updated');
      dispatch(
        upsertApprovalRequestInRedux({
          approvalRequest: response,
          picklistOptions,
          tenantId,
          stopForSelectedAsset,
        })
      );

      return response;
    } catch (e) {
      logUtils.logError(e, 'Updating Approval Request failed');
      throw e;
    } finally {
      dispatch(setLoader(false));
    }
  };
}

export function upsertWorkRequest(
  formValues,
  schema,
  {
    originalTask,
    picklistOptions,
    loggedInUser,
    fieldId,
    tenantId,
    tasksEditMode,
    stopForSelectedAsset,
    taskActionBeingDone,
    parentTaskTemplate,
  }
) {
  return async (dispatch) => {
    dispatch(setLoader(true));
    try {
      const updateOrCreate = taskActionBeingDone || TASK_ACTION.UPDATE;
      const updatedWorkRequest = TaskMappers.mapFormValuesToTask(formValues, schema, {
        originalTask,
        picklistOptions,
        loggedInUser,
        fieldId,
        tasksEditMode,
        taskActionBeingDone: updateOrCreate,
        parentTaskTemplate,
      });

      const response = await ApiService.upsertTask(updatedWorkRequest);
      if (response.isApprovalWorkflow) {
        if (updateOrCreate === TASK_ACTION.CREATE) {
          toastr.success('Work Request created');
        } else {
          toastr.success('Work Request updated');
        }
        dispatch(
          upsertWorkRequestInRedux({
            workRequest: response,
            picklistOptions,
            tenantId,
            stopForSelectedAsset,
          })
        );
      } else {
        toastr.success('Task Created');
      }
      return response;
    } catch (e) {
      logUtils.logError(e, 'Updating Work Request failed');
      throw e;
    } finally {
      dispatch(setLoader(false));
    }
  };
}

export function filterTasks({ fieldId, approverId, requestorId, startDate, endDate, approvalStatus }) {
  return async (dispatch) => {
    const startDateGreaterThan = moment(startDate).startOf('day').toDate();
    const endDateLessThan = moment(endDate).endOf('day').toDate();
    dispatch(setLoader(true));
    try {
      const response = await ApiService.bulkDownloadTasks({
        fieldId,
        approverId,
        requestorId,
        fromDate: startDateGreaterThan,
        toDate: endDateLessThan,
        isApprovalWorkflow: true,
        approvalStatus,
      });
      if (!response) {
        throw new Error('Fetching requests failed');
      }
      const tasks = response.map((task) => {
        task.assignee = JSON.stringify(task.assignee || {});
        task.data = JSON.stringify(task.data || {});
        return task;
      });
      if (approverId) {
        dispatch(loadApprovalRequestsInRedux(tasks));
      } else if (requestorId) {
        dispatch(loadWorkRequestsInRedux(tasks));
      }
      
    } catch (e) {
      logUtils.logError(e, 'Fetching Tasks Failed');
      dispatch(loadApprovalRequestsInRedux([]));
    } finally {
      dispatch(setLoader(false));
    }
  };
}

export function bulkApprove(data) {
  return async (dispatch) => {
    try {
      const updatedTasks = await ApiService.bulkApprove(data);
      const { taskToBeDeleted, taskToBeUpdated } = updateTaskAfterBulkApproval(updatedTasks);
      dispatch(updateApprovalRequests(taskToBeUpdated, taskToBeDeleted));
    } catch (e) {
      logUtils.logError(e, 'Bulk Approve Failed');
      throw e;
    }
  };
}

function updateRequestInRedux({ type, dispatch, filteredTasks, taskToBeDeleted }) {
  if (type === REQUEST_TYPE.APPROVAL_REQUEST) {
    dispatch(updateApprovalRequests(filteredTasks, taskToBeDeleted));
  } else if (type === REQUEST_TYPE.WORK_REQUEST) {
    dispatch(updateWorkRequests(filteredTasks, taskToBeDeleted));
  }
}

export function updateOrInsertTasks(tasks, deletedTasks, type) {
  return (dispatch) => {
    const filteredTasks = _.uniqBy(_.reverse(tasks), 'id'); // it may happen subscriptions happened for same task id multiple times, hence here making sure that latest task is being served to reducer
    filteredTasks.forEach((task) => {
      Utility.stripFromTypeName(task);
      Utility.stripFromTypeName(task.assigneeIds);
      Utility.stripFromTypeName(task.schedule);
      const assignee = JSON.parse(task.assignee);
      const data = JSON.parse(task.data);
      // eslint-disable-next-line no-param-reassign
      task.assignee = typeof assignee === 'string' ? assignee : task.assignee;
      // eslint-disable-next-line no-param-reassign
      task.data = typeof data === 'string' ? data : task.data;
      task.approvalInfo = typeof task.approvalInfo === 'string' ? JSON.parse(task.approvalInfo) : task.approvalInfo;
      task.globalAttributes =
        typeof task.globalAttributes === 'string' ? JSON.parse(task.globalAttributes) : task.globalAttributes;
      if (task.template && task.template.length) {
        task.template = task.template.map((item) => {
          return typeof item === 'string' ? JSON.parse(item) : item;
        });
      }
    });
    const taskToBeDeleted = _.uniqBy(_.reverse(deletedTasks), 'id');
    updateRequestInRedux({ type, dispatch, filteredTasks, taskToBeDeleted });
  };
}

export function toggleWatcher({ task, loggedInUserId, type }) {
  return async (dispatch) => {
    const oldWatcherIds = task.watcherIds;
    try {
      const loggedInUserIndex = task.watcherIds?.indexOf(loggedInUserId);
      let newWatcherIds = _.clone(task.watcherIds);
      if (loggedInUserIndex > -1) {
        newWatcherIds.splice(loggedInUserIndex, 1);
      } else {
        newWatcherIds = newWatcherIds ?? [];
        newWatcherIds.push(loggedInUserId);
      }
      const taskToBeUpdated = { id: task.id, watcherIds: newWatcherIds };
      updateRequestInRedux({ type, dispatch, filteredTasks: [{ ...task, ...taskToBeUpdated }], taskToBeDeleted: [] });
      const response = await ApiService.upsertTask(taskToBeUpdated);
      const taskId = _.get(response, 'id');
      if (!taskId) {
        throw new Error(`task ${task.id} not updated for watcher`);
      }
    } catch (e) {
      toastr.error('Task Watcher not updated');
      logUtils.logError(e);
      const revertUpdatedTask = { id: task.id, watcherIds: oldWatcherIds };
      updateRequestInRedux({ type, dispatch, filteredTasks: [{ ...task, ...revertUpdatedTask }], taskToBeDeleted: [] });
    }
  };
}
